import React from 'react';
import { FaInfoCircle } from 'react-icons/fa';
import Tooltip from '@material-ui/core/Tooltip';

const InfoIcon = () => {
  const tooltipText = "Para prova final a nota é exatamente a nota obtida. Para provas substitutivas e suplementares, a nota final será limitada a 7,0, que é a média necessária para aprovação no curso. Isso significa que, se o aluno tirar 7,0 ou mais na prova, a nota registrada será 7,0. Já se o aluno tirar menos de 7,0, a nota final será exatamente a que ele obteve na prova.";

  return (
    <Tooltip 
      title={tooltipText}
      placement="top"
      arrow
    >
      <span style={{ display: 'inline-block' }}>
        <FaInfoCircle 
          size={14} 
          color="#27aae1" 
          style={{ 
            marginLeft: '5px', 
            cursor: 'pointer',
            verticalAlign: 'middle'
          }} 
        />
      </span>
    </Tooltip>
  );
};

export default InfoIcon;
